export function addresses(state) {
  if (
    state.direcciones &&
    typeof state.direcciones === "object" &&
    state.direcciones.constructor === Array
  ) {
    return state.direcciones;
  }

  return [];
}
export function defecto(state) {
  return state.direcciones.filter(address => address.default);
}
